module.exports = {
	"description": "A list of vegetables.",
	"vegetables": [
		"acorn squash",
		"alfalfa sprout",
		"amaranth",
		"anise",
		"artichoke",
		"arugula",
		"asparagus",
		"aubergine",
		"azuki bean",
		"banana squash",
		"basil",
		"bean sprout",
		"beet",
		"black bean",
		"black-eyed pea",
		"bok choy",
		"borlotti bean",
		"broad beans",
		"broccoflower",
		"broccoli",
		"brussels sprout",
		"butternut squash",
		"cabbage",
		"calabrese",
		"caraway",
		"carrot",
		"cauliflower",
		"cayenne pepper",
		"celeriac",
		"celery",
		"chamomile",
		"chard",
		"chayote",
		"chickpea",
		"chives",
		"cilantro",
		"collard green",
		"corn",
		"corn salad",
		"courgette",
		"cucumber",
		"daikon",
		"delicata",
		"dill",
		"eggplant",
		"endive",
		"fennel",
		"fiddlehead",
		"frisee",
		"garlic",
		"gem squash",
		"ginger",
		"green bean",
		"green pepper",
		"habanero",
		"herbs and spice",
		"horseradish",
		"hubbard squash",
		"jalapeno",
		"jerusalem artichoke",
		"jicama",
		"kale",
		"kidney bean",
		"kohlrabi",
		"lavender",
		"leek ",
		"legume",
		"lemon grass",
		"lentils",
		"lettuce",
		"lima bean",
		"mamey",
		"mangetout",
		"marjoram",
		"mung bean",
		"mushrooms",
		"mustard green",
		"navy bean",
		"nettles",
		"new zealand spinach",
		"nopale",
		"okra",
		"onion",
		"oregano",
		"paprika",
		"parsley",
		"parsnip",
		"patty pan",
		"peas",
		"pinto bean",
		"potato",
		"pumpkin",
		"radicchio",
		"radish",
		"rhubarb",
		"rosemary",
		"runner bean",
		"rutabaga",
		"sage",
		"scallion",
		"shallot",
		"skirret",
		"snap pea",
		"soy bean",
		"spaghetti squash",
		"spinach",
		"squash ",
		"sweet potato",
		"tabasco pepper",
		"taro",
		"tat soi",
		"thyme",
		"tomato",
		"topinambur",
		"tubers",
		"turnip",
		"wasabi",
		"water chestnut",
		"watercress",
		"white radish",
		"yam",
		"zucchini"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/foods/vegetables.json
 **/